import {
  throwMovedAgentNativeModule,
  type DeprecatedExport,
} from "../../package-lifecycle/upgrade-error.js";

throwMovedAgentNativeModule(
  "@agent-native/core/client/components/ui/sheet",
  "@agent-native/toolkit/ui/sheet",
);

/** @deprecated @agent-native/core/client/components/ui/sheet moved to @agent-native/toolkit/ui/sheet. Run: npx @agent-native/core@latest upgrade --codemods */
export const Sheet =
  undefined as DeprecatedExport<"@agent-native/core/client/components/ui/sheet moved to @agent-native/toolkit/ui/sheet. Run: npx @agent-native/core@latest upgrade --codemods">;

/** @deprecated @agent-native/core/client/components/ui/sheet moved to @agent-native/toolkit/ui/sheet. Run: npx @agent-native/core@latest upgrade --codemods */
export const SheetClose =
  undefined as DeprecatedExport<"@agent-native/core/client/components/ui/sheet moved to @agent-native/toolkit/ui/sheet. Run: npx @agent-native/core@latest upgrade --codemods">;

/** @deprecated @agent-native/core/client/components/ui/sheet moved to @agent-native/toolkit/ui/sheet. Run: npx @agent-native/core@latest upgrade --codemods */
export const SheetContent =
  undefined as DeprecatedExport<"@agent-native/core/client/components/ui/sheet moved to @agent-native/toolkit/ui/sheet. Run: npx @agent-native/core@latest upgrade --codemods">;

/** @deprecated @agent-native/core/client/components/ui/sheet moved to @agent-native/toolkit/ui/sheet. Run: npx @agent-native/core@latest upgrade --codemods */
export const SheetDescription =
  undefined as DeprecatedExport<"@agent-native/core/client/components/ui/sheet moved to @agent-native/toolkit/ui/sheet. Run: npx @agent-native/core@latest upgrade --codemods">;

/** @deprecated @agent-native/core/client/components/ui/sheet moved to @agent-native/toolkit/ui/sheet. Run: npx @agent-native/core@latest upgrade --codemods */
export const SheetFooter =
  undefined as DeprecatedExport<"@agent-native/core/client/components/ui/sheet moved to @agent-native/toolkit/ui/sheet. Run: npx @agent-native/core@latest upgrade --codemods">;

/** @deprecated @agent-native/core/client/components/ui/sheet moved to @agent-native/toolkit/ui/sheet. Run: npx @agent-native/core@latest upgrade --codemods */
export const SheetHeader =
  undefined as DeprecatedExport<"@agent-native/core/client/components/ui/sheet moved to @agent-native/toolkit/ui/sheet. Run: npx @agent-native/core@latest upgrade --codemods">;

/** @deprecated @agent-native/core/client/components/ui/sheet moved to @agent-native/toolkit/ui/sheet. Run: npx @agent-native/core@latest upgrade --codemods */
export const SheetOverlay =
  undefined as DeprecatedExport<"@agent-native/core/client/components/ui/sheet moved to @agent-native/toolkit/ui/sheet. Run: npx @agent-native/core@latest upgrade --codemods">;

/** @deprecated @agent-native/core/client/components/ui/sheet moved to @agent-native/toolkit/ui/sheet. Run: npx @agent-native/core@latest upgrade --codemods */
export const SheetPortal =
  undefined as DeprecatedExport<"@agent-native/core/client/components/ui/sheet moved to @agent-native/toolkit/ui/sheet. Run: npx @agent-native/core@latest upgrade --codemods">;

/** @deprecated @agent-native/core/client/components/ui/sheet moved to @agent-native/toolkit/ui/sheet. Run: npx @agent-native/core@latest upgrade --codemods */
export const SheetTitle =
  undefined as DeprecatedExport<"@agent-native/core/client/components/ui/sheet moved to @agent-native/toolkit/ui/sheet. Run: npx @agent-native/core@latest upgrade --codemods">;

/** @deprecated @agent-native/core/client/components/ui/sheet moved to @agent-native/toolkit/ui/sheet. Run: npx @agent-native/core@latest upgrade --codemods */
export const SheetTrigger =
  undefined as DeprecatedExport<"@agent-native/core/client/components/ui/sheet moved to @agent-native/toolkit/ui/sheet. Run: npx @agent-native/core@latest upgrade --codemods">;
